import { useSyncExternalStore } from 'react'

function subscribe(cb: () => void): () => void {
  window.addEventListener('online', cb)
  window.addEventListener('offline', cb)
  return () => {
    window.removeEventListener('online', cb)
    window.removeEventListener('offline', cb)
  }
}

/**
 * Browser connectivity. `navigator.onLine === true` only means "has a network interface"; a
 * captive village Wi-Fi can still fail — callers treat ApiError.kind === 'network' as offline too.
 */
export function useNetworkStatus(): { online: boolean } {
  const online = useSyncExternalStore(
    subscribe,
    () => navigator.onLine,
    () => true,
  )
  return { online }
}
